module.exports = __webpack_public_path__ + "h5/img/noCollection.71f482e8.png";